export default "__VITE_ASSET__CLsQ5Q5X__"